import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SyncTasksSubListComponent } from '../syn-task-list/syn-task-list.component';
import { HttpClient } from '@angular/common/http';
import { chunk } from 'lodash';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@root/shared/service/translate.service';

enum TaskStatus {
  Success = 'success',
  Failed = 'failed',
  InProgress = 'in_progress',
  PartiallyFailed = 'partially_failed',
}

@Component({
  selector: 'host-sync-tasks',
  templateUrl: './sync-tasks.component.html',
  styleUrls: ['./sync-tasks.component.scss'],
})
export class SyncTasksComponent implements OnInit {
  private readonly ListApi = '/api/task/batch_list';
  private readonly RetryApi = '/api/task/batch_retry';

  readonly TaskStatus: typeof TaskStatus = TaskStatus;

  readonly StatusMap: Record<TaskStatus, string> = {
    [TaskStatus.Failed]: 'word.task_status.failed',
    [TaskStatus.PartiallyFailed]: 'word.task_status.partially_failed',
    [TaskStatus.InProgress]: 'word.task_status.in_progress',
    [TaskStatus.Success]: 'word.task_status.successful',
  };

  page = 1;
  pageSize = 20;

  total = 0;
  listOfTask = [];

  initialized = false;

  constructor(
    private modal: NzModalService,
    private http: HttpClient,
    private msg: NzMessageService,
    private t: TranslateService
  ) {}

  ngOnInit() {
    this.fetchBatchList();
  }

  onClickTask(task) {
    this.displaySubTasksModal(task);
  }

  onClickRetry(task) {
    if (!task.retried && !task.loading) {
      console.log('task: ', task);
      this.requestRetryTask(task);
    }
  }

  onPageChange() {
    this.fetchBatchList();
  }

  private fetchBatchList() {
    const params = {
      page: this.page,
      page_size: this.pageSize,
    };

    this.http.get(this.ListApi, { params }).subscribe((rst: any) => {
      this.initialized = true;

      this.listOfTask = this.formatTaskField(rst?.data?.list);
      this.total = rst?.data?.total;

      console.log('list of task: ', this.listOfTask);
    });
  }

  private requestRetryTask(task) {
    task.loading = true;

    const params = { id: task.id };

    this.http.post(this.RetryApi, params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t('word.retried'));
        this.fetchBatchList();
      } else {
        task.loading = false;
      }
    });
  }

  private formatTaskField(list: any[]) {
    return list.map((task) => {
      const titles = task.titles;
      const [first, rest] = chunk(titles);
      const title_str = first?.[0] + (rest?.length ? `, ${rest.length}+` : '');
      task.title_str = title_str;
      return task;
    });
  }

  private displaySubTasksModal(task) {
    this.modal.create({
      nzTitle: task.format_str,
      nzContent: SyncTasksSubListComponent,
      nzWidth: 850,
      nzFooter: null,
      nzComponentParams: {
        id: task.id,
      },
    });
  }
}
